import {Component, Input, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  GateweeHeaderComponent,
  HeaderConfig,
} from './gatewee-header/gatewee-header.component';
import {
  GateweeNavigationComponent,
  NavigationConfig,
} from './gatewee-navigation/gatewee-navigation.component';
import {UtilsModule} from '@gatewee/helpers';

// Re-export interfaces for convenience
export type {
  HeaderConfig,
  Profile,
} from './gatewee-header/gatewee-header.component';
export type {
  MenuItem,
  MenuSubItem,
  NavigationConfig,
} from './gatewee-navigation/gatewee-navigation.component';

const navigationCollapsedKey = 'gatewee-navigation-collapsed';

@Component({
  selector: 'gatewee-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    GateweeHeaderComponent,
    GateweeNavigationComponent,
    UtilsModule,
  ],
  templateUrl: './gatewee-wrapper.component.html',
  styleUrls: ['./gatewee-wrapper.component.css'],
})
export class GateweeWrapperComponent implements OnInit {
  // Internal state for navigation collapse - defaults to expanded (false)
  isNavigationCollapsed = signal(false);

  // Header configuration
  @Input() headerConfig: HeaderConfig | null = null;

  // Navigation configuration
  @Input() navigationConfig: NavigationConfig | null = null;

  ngOnInit(): void {
    // Mobile: always start with the off-canvas drawer closed (ignore saved desktop expand state).
    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
      this.isNavigationCollapsed.set(true);
      return;
    }
    const savedCollapsed = localStorage.getItem(navigationCollapsedKey);
    if (savedCollapsed === 'true') {
      this.isNavigationCollapsed.set(true);
    }
  }

  onNavigationToggle(collapsed: boolean): void {
    this.isNavigationCollapsed.set(collapsed);
    // Save preference to localStorage
    localStorage.setItem(navigationCollapsedKey, String(collapsed));
  }

  closeMobileMenu(): void {
    this.onNavigationToggle(true);
  }

  getEffectiveHeaderConfig(): HeaderConfig | null {
    return this.headerConfig;
  }

  getEffectiveNavigationConfig(): NavigationConfig | null {
    return this.navigationConfig;
  }
}
